import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import BiographyPage from "@/pages/BiographyPage";
import BandsPage from "@/pages/BandsPage";
import QuartettPage from "@/pages/QuartettPage";
import FullBandPage from "@/pages/FullBandPage";
import EventMusicPage from "@/pages/EventMusicPage";
import MusicPage from "@/pages/MusicPage";
import DiscographyPage from "@/pages/DiscographyPage";
import VideoPage from "@/pages/VideoPage";
import EquipmentPage from "@/pages/EquipmentPage";
import PressPage from "@/pages/PressPage";
import ContactPage from "@/pages/ContactPage";
import { ImprintPage, PrivacyPage } from "@/pages/LegalPage";
import NotFoundPage from "@/pages/NotFoundPage";
import LessonsPage from "@/pages/LessonsPage";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/de" replace />} />
          <Route path="/impressum" element={<Navigate to="/de/impressum" replace />} />
          <Route path="/datenschutz" element={<Navigate to="/de/datenschutz" replace />} />
          <Route path="/kontakt" element={<Navigate to="/de/contact" replace />} />
          <Route path="/unterricht" element={<Navigate to="/de/lessons" replace />} />
          <Route path="/saxunterricht" element={<Navigate to="/de/lessons" replace />} />
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="biography" element={<BiographyPage />} />
            <Route path="live" element={<Navigate to="." replace />} />
            <Route path="bands" element={<BandsPage />} />
            <Route path="bands/quartett" element={<QuartettPage />} />
            <Route path="bands/full-band" element={<FullBandPage />} />
            <Route path="bands/events" element={<EventMusicPage />} />
            <Route path="music" element={<MusicPage />} />
            <Route path="music/discography" element={<DiscographyPage />} />
            <Route path="music/video" element={<VideoPage />} />
            <Route path="equipment" element={<EquipmentPage />} />
            <Route path="press" element={<PressPage />} />
            <Route path="lessons" element={<LessonsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="impressum" element={<ImprintPage />} />
            <Route path="datenschutz" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
